export class ParkingSpace {
  id: number;
  name: string;
  rentId: number;
  availableDate: any;
}
